<div [appStoryblok]="_editable">
  <div class="h2 mt-5 pt-4 mb-0 text-center" *ngIf="title">{{ title }}</div>
  <div class="ticker" #parent style="--width: -137%">
    <div class="ticker-item" #element>
      <ng-container *ngFor="let blok of images">
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic
      ></ng-container>
    </div>
    <div class="ticker-item">
      <ng-container *ngFor="let blok of images">
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic
      ></ng-container>
    </div>
  </div>
</div>
